export default __webpack_public_path__ + "static/media/disease-detection.fa6eef86.png";